import React, { useState } from "react";
import "./style.css";
import CloseIcon from '@mui/icons-material/Close';
const ResetPassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorDisplay, setErrorDisplay] = useState(false);
  const CloseError = () => {
    setErrorDisplay(false);
  }

  const onClick = () => {
    let hasError = true;

    if (oldPassword === "") {
      setErrorDisplay(true);
      hasError = false;
    } else {
      setErrorDisplay(false);
    }
    if (newPassword === "") {
      setErrorDisplay(true);
      hasError = false;
    } else {
      setErrorDisplay(false);
    }
    if (hasError === true) {
    }
  };

  return (
    <div className="loginMainDiv">
      <div className="loginDiv">
        <div>
          <h2 className="loginText">Reset Password </h2>
          <div>
            <div className="mb-3 inputFieldDivLogin">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputLoginLabel"
              >
                OLD PASSWORD
              </label>
              <input
                className="form-control input-style-resetPass inputBorderNone"
                placeholder="Old Password"
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </div>
            <div className="mb-3 inputFieldDivLogin">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputLoginLabel"
              >
                NEW PASSWORD
              </label>
              <input
                className="form-control input-style-resetPass inputBorderNone"
                placeholder="New Password"
                type="Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <div className="forgotPasswordMainDiv">
              </div>
            </div>

            <div className="submitBtnDiv-resetPass">
              <button
                type="submit"
                className="btn btn-primary submitBtnForgotpassword"
                onClick={onClick}
              >
                Reset Password
              </button>
            </div>
            {errorDisplay === true && (
              <div className="forgotPasswordMainDiv">
                <div className="error-style-Login">
                  Invalid password
                </div>
                <div className="error-style-Login-btn" onClick={CloseError}><CloseIcon style={{fontSize: '0.8rem'}} /></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
